import { gql } from '@lcs/shared/api';

export const getExtensionGroupsQuery = gql`
   query GetExtensionGroups($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      extensionGroupsConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            createDate
            createUser {
               userId
               name
            }
            extensionGroupId
            name
            description
            accountId
            extensionGroupCount
            extensionGroupExtensionsConnection {
               items {
                  extensionGroupExtensionId
                  extension {
                     extensionId
                     number
                     name
                     type
                  }
               }
            }
         }
      }
   }
`;
